import React, { useEffect } from 'react';
import c from 'classnames';
import { AnimatePresence, motion, MotionConfig } from 'framer-motion';

import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import { WysiwygField } from '@uncinc/uncinc-react-kitchen-sink';

import { useWebformContext } from '../../../../context/WebformContext';
import type { WebformProcessedText } from '../../types';

export interface WebformAssessmentProcessedTextProps {
  entity: ImmutableEntity<WebformProcessedText>;
}

// eslint-disable-next-line max-len
const WebformAssessmentProcessedText: React.FC<WebformAssessmentProcessedTextProps> = ({ entity }) => {
  const { updateCurrentElement } = useWebformContext();

  const component = entity.toJS();
  const key = component['#webform_key'];
  const text = component['#text'];
  const wrapperAttributes = component['#wrapper_attributes'];
  const classNames = c('WebformAssessmentProcessedText', 'WebformProcessedText', wrapperAttributes?.class[0] || '');

  useEffect(() => {
    updateCurrentElement(key);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={classNames}>
      <MotionConfig transition={{ duration: 0.3 }}>
        <AnimatePresence initial={false} mode="wait">
          <motion.div
            key="form"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            <WysiwygField
              key={key}
              property="schema:text"
              html={text}
            />
          </motion.div>
        </AnimatePresence>
      </MotionConfig>
    </div>
  );
};

export default WebformAssessmentProcessedText;
